import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStore } from '@store/auth.store';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoggedGuard {
  constructor(
    private authStore: AuthStore,
    private router: Router
  ) {}

  canActivate() {
    return this.authStore.isAuthenticated$.pipe(
      take(1),
      map(({ isAuthenticated, otpVerified }) => {
        // Fully authenticated users have no business on the login page
        if (isAuthenticated && otpVerified) {
          this.router.navigate(['/']);
          return false;
        }

        // Not authenticated, or mid-OTP (the OTP form lives on the login page)
        return true;
      })
    );
  }
} 